import React, { type ReactNode } from 'react';
import { useNotification } from '@/hooks/useNotification';
import { NotificationContainer } from '@/components/ui/Notification';
import { NotificationContext } from '@/contexts/NotificationContext';

interface NotificationProviderProps {
  children: ReactNode;
  placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
  children,
  placement = 'topRight',
}) => {
  const { notifications, success, error, warning, info, removeNotification } = useNotification();

  return (
    <NotificationContext.Provider value={{ success, error, warning, info }}>
      {children}
      <NotificationContainer
        notifications={notifications}
        onRemove={removeNotification}
        placement={placement}
      />
    </NotificationContext.Provider>
  );
};

